import { AfterViewInit, ElementRef, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TabloSidebarPanel } from './tablo-sidebar.types';

@Component({
    selector: 'lib-tablo-sidebar-shell',
    templateUrl: './tablo-sidebar-shell.component.html',
    styleUrls: ['./tablo-sidebar-shell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabloSidebarShellComponent implements AfterViewInit, OnChanges {
  @ViewChild('panelContent') private panelContent: ElementRef<HTMLElement>;
  private panelAnimation?: Animation;
  ngAfterViewInit(): void { this.animatePanel(); }
  ngOnChanges(changes: SimpleChanges): void { if (changes['panel']) this.animatePanel(); }
  private animatePanel(): void {
    if (!this.panelContent) return;
    this.panelAnimation?.cancel();
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.panelAnimation = this.panelContent.nativeElement.animate([{ opacity: 0, transform: 'translateX(8px)' }, { opacity: 1, transform: 'translateX(0)' }], { duration: 160, easing: 'ease-out' });
  }

  @Input() title = '';
  @Input() showBack = false;
  @Input() panel: TabloSidebarPanel = 'main';
  @Output() back = new EventEmitter<void>();
}
